(() => {
  function amounts(saleCents, netCentsPerUSD, cratingRate, rate) {
    const sourceListUSD = Math.round(saleCents * 78 / (netCentsPerUSD * 100));
    const netCents = sourceListUSD * netCentsPerUSD;
    const cratingNetCents = Math.round(netCents * cratingRate);
    const tariffNetCents = Math.round((netCents + cratingNetCents) * rate);
    const packingCents = Math.round(cratingNetCents * 100 / 78);
    const feeCents = Math.round(tariffNetCents * 100 / 89);
    return { sourceListUSD, packingCents, feeCents, totalCents: saleCents + packingCents + feeCents };
  }
  function productFromTotal(totalCents, netCentsPerUSD, cratingRate, rate) {
    let low = 0;
    let high = totalCents;
    while (low <= high) {
      const mid = Math.floor((low + high) / 2);
      const calculated = amounts(mid, netCentsPerUSD, cratingRate, rate).totalCents;
      if (calculated === totalCents) return mid;
      if (calculated < totalCents) low = mid + 1;
      else high = mid - 1;
    }
    return null;
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { amounts, productFromTotal };
    return;
  }
  const bind = n => {
    const config = document.querySelector('[data-ae-final-pricing]');
    if (!config) return;
    const jq = window.jQuery;
    if (!jq) { if (n < 200) setTimeout(() => bind(n + 1), 50); return; }
    const update = options => {
      document.querySelectorAll('.ae-price-summary').forEach(root => {
        const code = root.dataset.aeCurrency || 'CAD';
        const us = root.dataset.aeMarketCountry === 'US';
        if (code !== 'CAD' && !us) return;
        const product = root.querySelector('[data-ae-product-price]');
        const value = options?.current_prices?.price;
        const price = value === undefined ? Number((product?.textContent || '').replace(/[^0-9.-]/g, '')) : Number(value);
        if (!Number.isFinite(price) || price <= 0) return;
        let rate = Number(config.dataset.aeBaseRate);
        const selected = jq('.ae-model input:checked').filter(function () { return this.getClientRects().length > 0; });
        const explicit = selected.closest('.choice').find('[data-ae-tariff-rate]').toArray().map(el => Number(el.dataset.aeTariffRate));
        if (explicit.length) rate = explicit.includes(0.25) ? 0.25 : 0.5;
        else if (config.dataset.aeRateMode === 'mixed' && selected.length) {
          rate = selected.closest('.choice').find('[data-ae-wood]').length ? 0.25 : 0.5;
        }
        const crating = us ? 0 : Number(root.dataset.aeCratingRate || 0);
        const net = Number(config.dataset.aeNetCents);
        const receivedCents = Math.round(price * 100);
        const formulaActive = config.dataset.aeCheckoutPricing === 'true' && !us;
        const saleCents = formulaActive && value !== undefined ? productFromTotal(receivedCents, net, crating, rate) : receivedCents;
        if (saleCents === null) {
          root.dataset.aePricingError = 'unreconciled-total';
          return;
        }
        delete root.dataset.aePricingError;
        const calculated = us ? { packingCents: 0, feeCents: 0, totalCents: saleCents } : amounts(saleCents, net, crating, rate);
        const money = cents => new Intl.NumberFormat('en-CA', { style: 'currency', currency: code }).format(cents / 100) + ' ' + code;
        const write = (selector, text) => root.querySelectorAll(selector).forEach(el => { el.textContent = text; });
        write('[data-ae-product-price]', money(saleCents));
        write('[data-ae-packing-price]', money(calculated.packingCents));
        write('[data-ae-import-fee]', money(calculated.feeCents));
        write('[data-ae-before-freight]', money(calculated.totalCents));
        write('[data-ae-import-rate]', (rate * 100) + '%');
        root.querySelectorAll('[data-ae-crating-row]').forEach(el => { el.hidden = us || crating <= 0; });
        jq('[data-ae-canada-surcharge]').toggle(!us);
      });
    };
    jq(window).off('dpoPriceUpdate.aeFinalAudit').on('dpoPriceUpdate.aeFinalAudit', (event, options) => requestAnimationFrame(() => update(options)));
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind(0));
  else bind(0);
  document.addEventListener('shopify:section:load', () => bind(0));
})();
